import type { FooterContentProps } from './footer.types'

import Box from '../box'
import { useStyleConfig, vui } from '../core'
import { cs } from '../utils'
import { useFooterContext } from './context'

/** Controls max-width of the content and centers itself horizontally. */
export const FooterContent = vui<'div', FooterContentProps>((props, ref) => {
  const { className, ...rest } = props
  const styles = useStyleConfig('Footer', useFooterContext())

  return (
    <Box
      className={cs('vui-footerContent', className)}
      column
      fontSize={{ xs: 12, sm: 12, md: 14 }}
      maxW={{ xs: 344, sm: 412, md: 780, lg: 782, xl: 888 }}
      mx="auto"
      ref={ref}
      w="100%"
      {...styles.content}
      {...rest}
    />
  )
})

FooterContent.displayName = 'FooterContent'
export default FooterContent
